<template>
	<div>	
		<div class="row">
			<div class="col-md-12 mb-2 mt-2 p-0">
				<div class="row">
					<div class="col-md-12">
						<h4>OVERVIEW FUEL KSO</h4>
					</div>
				</div>
			</div>

			<div class="col-md-8 pl-0">
				<div class="row">
					<div class="col-md-6 ">
						<sequential-entrance>
						<ListCompare title="SALES (KSO)" unit="KL" comp=1 :data="ytd.sales" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=0&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
						</sequential-entrance>
					</div>
					<div class="col-md-6 ">
						<ListCompare title="LOSSES (KSO)" unit="%" comp=-1 :data="ytd.losses" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=1&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
					</div>
				</div>
				<div class="mb-4">
					<BarCard title="SALES WEEKLY (KL) (KSO)" :data="sales.weekly" :width="500" :height="400"/>
				</div>
				<div class="row">
					<div class="col-md-6">
					<div class="card cardptpr mb-4">
						<div class="card-header cardptpr p-3 pb-0 pt-0">
							<H6>PAYMENT YTD (M)</H6>
						</div>
						<div class="card-body p-3 pt-0" style="width:280px;">
							<PieChart :data="this.pieChartDataPayment" 
								:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
                        </div>
                    </div>
                    </div>
					<div class="col-md-6">
						<ListCompare title="CASH PERCENTAGE (KSO)" unit="%" comp=-1 :data="ytd.pctcash" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=2&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
                    </div>
				</div>
			</div>
			<div class="col-md-4 mb-4 pr-0">
				<div class="mb-4">
					<ListCompare title="REALISASI BBK (KSO)" unit="%" comp=1 :data="ytd.bbk" itemcol="Info" valuecol="Value"
						:url="'/fuel/report2?tab=0&detail2=group&' + this.getYTDfilter('dateStart', 'dateEnd')"/>
				</div>
				<div class="">
					<ListItem class=" mb-4" title="NO OF STATIONS (KSO)" :data="spbu.types" itemcol="StationType" valuecol="Cnt" 
						url="/fuel/outlet?"/>

					<ListItem class=" mb-4" warning=1 title="CRITICAL STOCK BY PRODUCT (KSO)" :data="critical.product" itemcol="ProductName" valuecol="Cnt"
						url="/fuel/report2?tab=3&status=CRITICAL&detail2=product"/>

					<ListItem v-if="false" warning=1 title="CRITICAL STOCK BY AREA (KSO)" prefix="AREA" :data="critical.area" itemcol="SalesArea" valuecol="Cnt"
						url="/fuel/report2?tab=3&status=CRITICAL&detail1=area"/>

					<ListItem warning=1 title="CRITICAL STOCK BY REGION (KSO)" prefix="REGION" :data="critical.region" itemcol="RegionPertareId" valuecol="Cnt"
						url="/fuel/report2?tab=3&status=CRITICAL&detail1=region"/>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'

export default{
	extends: Fuel,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		PieChart,
		Footer            
	},

	data() {
		return {
            pieChartDataPayment : [],
		}
	},

	computed:{
	},

    mounted(){
		this.$emit('childrenRoute');
		this.loadYTDKso();
		this.loadSalesYTDKso();
		this.loadCriticalKso();
		this.loadStationListKso();
		this.loadStationTypesKso();
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'

    },
    methods:{
        setPieChartData(){
			var warna=[]
			warna["NON CASH"]='rgba(255,0,0,1)'
			warna["CASH"]='rgba(0,0,255,1)'				

			let result = this.processPieChart(
				[
					{
						transtype: "CASH", 
						amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountCash
					},
					{
						transtype: "NON CASH", 
						amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountNonCash
					}
				], 
				"amount", "transtype", 1000000000, 2, warna); 
			this.pieChartDataPayment = result;
        },
		loadYTDKso() {
			//let url = Config().apiURL+ "/fuel2/ytd?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			let url = Config().apiURL+ "/v1/fuel2/ytd2?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data) {
					this.ytd = {
						raw: result.data,
						sales: this.processYTD(result.data.summary, "Info", "SalesVolume", false, "Grup", 1000, 0),
						losses: this.processYTD(result.data.summary, "Info", "LossesVolume", "SalesVolume", "Grup", 0.01, 2),
						bbk: this.processYTD(result.data.summary, "Info", "SalesVolumeBBK", "SalesVolumeAll", "Grup", 0.01, 2),
						cash: this.processYTD(result.data.cash, "Info", "AmountCash", false, "Grup", 1, 2),
						noncash: this.processYTD(result.data.cash, "Info", "AmountNonCash", false, "Grup", 1, 2),
						pctcash: this.processYTD(result.data.cash, "Info", "AmountCash", "AmountAll", "Grup", 0.01, 2)
					};

					this.setPieChartData();
				}
			})
		},	
		loadSalesYTDKso(){
			let url =Config().apiURL+"/fuel2/sales?period=daily&detail=product&owner=KSO"
				url += "&date-range-start="+Penanggalan().mingguSekarang
				url += "&date-range-end="+Penanggalan().kemarin
				url += (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.sales.weekly = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, true)
				}
			})
		},
		loadCriticalKso(satgas=0){			
			let url =Config().apiURL+"/fuel2/stock?satgas=" +satgas +"&status=CRITICAL&detail=product" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.product = result.data.data;
				}
			})

			//Change to Region below
			/*
			url =Config().apiURL+"/fuel2/stock?status=CRITICAL&detail=area" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.area = result.data.data;
				}
			})
			*/

			url =Config().apiURL+"/fuel2/stock?view=overview&status=CRITICAL&detail=region" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.region = result.data.data;
				}
			})
		},
		loadStationListKso(type='') {
			let url = Config().apiURL + "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},
		loadStationTypesKso() {
			let url = Config().apiURL + "/fuel2/station?detail=type" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + "&owner=KSO";
			AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.types = result.data.data;
				}
			})
		},
		//END METHODS
	}
}
</script>